import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'analysis/market-segment',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const MarketSegment = require('./containers/MarketSegment').default;
      const marketSegmentReducer = require('components/MarketSegment/reducers').default;

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'counter', reducer })
      injectReducer(store, { key: 'marketSegmentData', reducer: marketSegmentReducer });
      /*  Return getComponent   */
      cb(null, MarketSegment)

    /* Webpack named bundle   */
    }, 'campaign')
  }
})



// WEBPACK FOOTER //
// ./src/routes/MarketSegment/index.js